import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=a657663c&scoped=true"
import script from "./Explanation.vue?vue&type=script&lang=js"
export * from "./Explanation.vue?vue&type=script&lang=js"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=a657663c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a657663c",
  null
  
)

export default component.exports